import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// =============================================================================
// UI store — state visual ringan yang dipakai banyak komponen:
//   - sidebar collapsed (toggle di topbar)
//   - bottom panel collapsed/size (di-persist supaya user dapat preferensi balik)
// Di-persist ke localStorage.
// =============================================================================

interface UiState {
  sidebarCollapsed: boolean;
  bottomPanelSize: number; // persen tinggi (0-50). 0 = hidden.

  toggleSidebar: () => void;
  setSidebarCollapsed: (v: boolean) => void;
  setBottomPanelSize: (v: number) => void;
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      bottomPanelSize: 25,

      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
      setSidebarCollapsed: (v) => set({ sidebarCollapsed: v }),
      setBottomPanelSize: (v) => set({ bottomPanelSize: v }),
    }),
    { name: 'webgps-ui' },
  ),
);
